/* ─────────────────────────────────────────
   BASIC CHECK
───────────────────────────────────────── */
export const hasPermission = (
  permission,
  userPermissions = []
) => {
  if (!permission) return true;
  if (!Array.isArray(userPermissions)) return false;

  return userPermissions.includes(permission);
};

/* ─────────────────────────────────────────
   ANY PERMISSION (OR)
───────────────────────────────────────── */
export const hasAnyPermission = (
  permissions = [],
  userPermissions = []
) => {
  if (!permissions.length) return true;
  if (!Array.isArray(userPermissions)) return false;

  return permissions.some((perm) =>
    userPermissions.includes(perm)
  );
};

/* ─────────────────────────────────────────
   ALL PERMISSIONS (AND)
───────────────────────────────────────── */
export const hasAllPermissions = (
  permissions = [],
  userPermissions = []
) => {
  if (!permissions.length) return true;
  if (!Array.isArray(userPermissions)) return false;

  return permissions.every((perm) =>
    userPermissions.includes(perm)
  );
};

/* ─────────────────────────────────────────
   FILTER UI ITEMS BY PERMISSION
───────────────────────────────────────── */
export const filterByPermission = (
  items = [],
  userPermissions = []
) => {
  return items.filter((item) => {
    if (!item.permission) return true;
    return userPermissions.includes(item.permission);
  });
};
